import PropTypes from 'prop-types'
import React from 'react'
import { useInView } from 'react-intersection-observer'

import { GOODS_TYPES } from 'constants/sales'
import { ResizeContext } from 'contexts/Resize'
import { Row, Col, BoxBase } from 'styles/components/layout'
import { H1, Text } from 'styles/components/typography'

import BarAndBox from '../BarAndBox'
import { Content, Chart } from '../styles'

const WForeverMobile = ({ data }) => {
  const { dna, wgs } = GOODS_TYPES
  const { tablet, mobile } = React.useContext(ResizeContext)
  const [ref, inView] = useInView({
    threshold: 0.8,
    triggerOnce: true,
  })
  const isVisible = React.useMemo(() => {
    return tablet && inView
  }, [tablet, inView])

  return (
    <BoxBase>
      <Row ref={ref}>
        <Col width={1}>
          <Content>
            <H1 as="h3" dangerouslySetInnerHTML={{ __html: data.title }} />
            <Text dangerouslySetInnerHTML={{ __html: data.text }} />
          </Content>
        </Col>

        <Col width={1}>
          <Chart>
            <BarAndBox
              isMobile={mobile}
              productType={wgs}
              text={data[wgs]}
              isAnimationActive={isVisible}
            />
            <BarAndBox
              productType={dna}
              text={data[dna]}
              isAnimationActive={isVisible}
            />
          </Chart>
        </Col>
      </Row>
    </BoxBase>
  )
}

WForeverMobile.propTypes = {
  data: PropTypes.object.isRequired,
}

export default WForeverMobile
